import React, { useContext, useEffect, useState } from "react";
import { Button, Alert } from "react-bootstrap";
import AuthContext from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import CustomerService from "../services/CustomerService";
import ServiceModal from "../component/FormModal/ServiceModal";
import ServicesService from "../services/ServiceService";
import CustomerStatusUpdate from "../component/Common/CustomerStatusUpdate";
import PaginationComponent from "../component/Common/PaginationComponent";
import CustomerTable from "../component/Tables/CustomerTable";
import StatusButtons from "../component/Common/StatusButtons";
import CustomerModal from "../component/FormModal/CustomerModal";
import CustomerAssignModal from "../component/FormModal/CustomerAssignModal";
import CRMUserService from "../services/CRMUserService";
import AdvertisementModal from "../component/FormModal/AdvertisementModal";
import AdvertisementService from "../services/AdvertisementService";
import AdvertisementTable from "../component/Tables/AdvertisementTable";
import imageService from "../services/ImageServie";
import ViewAdvertisementsModal from "../component/Common/ViewAdvertisementsModal";
import logo from '../login-logo.png';
import ViewFollowUps from "../component/Common/ViewFollowUps";
import FollowUpService from "../services/FollowUpService";
import AdActivationByCity from "../component/FormModal/AdActivationByCity";
import PointRequest from "./PointRequest";
import { toast } from "react-toastify";

const ManagerDashboard = () => {
    const { user, isLoggedIn, logout } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const navigate = useNavigate();
    const [showServiceModal, setShowServiceModal] = useState(false);
    const [showAdvertisementModal, setShowAdvertisementModal] = useState(false);
    const [showCustomerADs, setShowCustomerADs] = useState(false);
    const [showCustomerModal, setShowCustomerModal] = useState(false);
    const [showCustomerAssignModal, setShowCustomerAssignModal] = useState(false);
    const [loginUserDetails, setLoginUserDetils] = useState(null);
    const [selectedCustomerId, setSelectedCustomerId] = useState(null);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [customersFilter, setCustomersFilter] = useState('all');
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0)
    const [totalElements, setTotalElements] = useState(0);
    const [size, setSize] = useState(15);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchBy, setSearchBy] = useState('');
    const [showFollowUps, setShowFollowUps] = useState(false);
    const [followUps, setFollowUps] = useState([]);
    const [alerts, setAlerts] = useState([]);
    const [showAdActivationModal, setShowAdActivationModal] = useState(false);
    const [showPointRequest, setshowPointRequest] = useState(false);
    const [exporting, setExporting] = useState(false);
    const [viewType, setViewType] = useState('customers');
    const [advertisements, setAdvertisements] = useState([]);
    const [adCurrentPage, setAdCurrentPage] = useState(0);
    const [adTotalPages, setAdTotalPages] = useState(0);
    const [adTotalElements, setAdTotalElements] = useState(0);
    const [adSearchTerm, setAdSearchTerm] = useState('');
    const [adSearchBy, setAdSearchBy] = useState('');
    const [adFilters, setAdFilters] = useState({ active: '', adType: '', planStatus: '' });
    const [editingAd, setEditingAd] = useState(null);

    useEffect(() => {
        if (!isLoggedIn()) {
            navigate('/login');
        } else if (user) {
            const role = user.role.replace(/^\[|\]$/g, '');
            if (role !== 'ROLE_SALES_MANAGER' && role !== 'ROLE_SALES_EXECUTIVE') {
                navigate('/unauthorised');
            } else {
                fetchLoginUser();
            }
        }
    }, [isLoggedIn, user, navigate]);

    useEffect(() => {
        if (loginUserDetails) {
            fetchCustomers();
        }
    }, [searchTerm, searchBy, currentPage, customersFilter, loginUserDetails]);

    useEffect(() => {
        if (viewType === 'advertisements') {
            fetchAdvertisementsList();
        }
    }, [viewType, adCurrentPage, adSearchTerm, adSearchBy, adFilters]);

    const adQueryParams = () => {
        const params = {};
        if (adFilters.active) params.active = adFilters.active;
        if (adFilters.adType) params.adType = adFilters.adType;
        if (adFilters.planStatus) params.planStatus = adFilters.planStatus;
        if (adSearchBy && adSearchTerm) {
            params.searchBy = adSearchBy;
            params.searchValue = adSearchTerm;
        }
        return params;
    };

    const handleAdSearch = (term, by) => {
        setAdSearchTerm(term);
        setAdSearchBy(by);
        setAdCurrentPage(0);
    };

    const handleAdFilter = (partial) => {
        setAdFilters((prev) => ({ ...prev, ...partial }));
        setAdCurrentPage(0);
    };

    const fetchAdvertisementsList = async () => {
        setLoading(true);
        setAdvertisements([]);
        const storedUser = JSON.parse(localStorage.getItem('user'));
        const token = storedUser?.token;
        try {
            const response = await AdvertisementService.getAdvertisements(adCurrentPage, size, token, null, adQueryParams());
            setAdvertisements(response.content);
            setAdTotalPages(response.totalPages);
            setAdTotalElements(response.totalElements);
        } catch (error) {
            console.error('Error fetching advertisements:', error);
            setAdvertisements([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchLoginUser = async () => {
        const storedUser = JSON.parse(localStorage.getItem('user'));
        const token = storedUser?.token;
        try {
            const response = await CRMUserService.getLogInUser(token);
            setLoginUserDetils(response);
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoginUserDetils(null)
            logout();
            navigate('/login');
        }
    }

    const fetchCustomers = async () => {
        setLoading(true);
        setCustomers([]);
        const storedUser = JSON.parse(localStorage.getItem('user'));
        const token = storedUser?.token;
        const role = storedUser.role.replace(/^\[|\]$/g, '');
        try {
            let response;
            if (searchTerm && searchBy) {
                response = await CustomerService.searchCustomers(searchBy, searchTerm, currentPage, size, token);
            } else {
                if (role === 'ROLE_SALES_MANAGER') {
                    response = await CustomerService.getAllCustomersByStatus(customersFilter, currentPage, size, token);
                } else if (role === 'ROLE_SALES_EXECUTIVE') {
                    response = await CustomerService.getCustomersForExecutive(loginUserDetails.id, customersFilter, currentPage, size, token);
                }
            }
            setCustomers(response.content);
            setTotalPages(response.totalPages);
            setTotalElements(response.totalElements);
        } catch (error) {
            console.error('Error fetching data:', error);
            setCustomers([]);
        } finally {
            setLoading(false);
            setSelectedCustomerId(null);
        }
    }

        // Fetch follow-ups function
        const fetchFollowUps = async () => {
            try {
                const token = JSON.parse(localStorage.getItem("user")).token;
                if (loginUserDetails) {
                    const data = await FollowUpService.getFollowUp(loginUserDetails.id, null ,token);
                    setFollowUps(data);
                }
            } catch (error) {
                toast.error("Failed to fetch follow-ups");
                console.error("Failed to fetch follow-ups:", error);
            }
        };

        // Effect to fetch follow-ups when component mounts or loginUserDetails changes
        useEffect(() => {
            if (loginUserDetails) {
                fetchFollowUps();
            }
        }, [loginUserDetails]);

        // Effect to check for alerts
        useEffect(() => {
            const intervalId = setInterval(() => {
                const now = new Date();
                const newAlerts = [];

                followUps.forEach((followUp) => {
                    const followUpTime = new Date(followUp.followUpDate);
                    const timeDifference = Math.abs(followUpTime - now) / 1000; // difference in seconds

                    // Trigger alert if the follow-up time is due and not completed
                    if (timeDifference > 0 && !followUp.completed) {
                        newAlerts.push(followUp);
                    }
                });

                setAlerts(newAlerts);
            }, 30000); // Check every 30 seconds

            return () => clearInterval(intervalId); // Cleanup interval on unmount
        }, [followUps]); // Dependency on followUps

        // Handle follow-up completion
        const handleFollowUpComplete = async (followUpId) => {
            try {
                const token = JSON.parse(localStorage.getItem('user')).token;
                const response = await FollowUpService.followUpComplete(followUpId, token);
                toast.success(response);
                 // Update local state to remove the alert
                setAlerts((prevAlerts) => prevAlerts.filter((alert) => alert.id !== followUpId));
                // After completing, fetch follow-ups again to get the latest list
                fetchFollowUps();
            } catch (error) {
                toast.error("Failed to mark follow-up as complete");
                console.error("Failed to mark follow-up as complete:", error.message);
            }
        };

    const handleFollowUpAdded = (response) => {
        if (response) {
            toast.success(response);

            fetchFollowUps();
        }
    };

        const handleFollowUpUpdate = (response) => {
            if (response) {
                fetchFollowUps();
            }
        };

    const handleLogout = () => {
        setLoginUserDetils(null)
        logout();
        navigate('/login');
    };

    const handleServiceSubmit = async (data) => {
        setFormLoading(true);
        try {
            const token = user.token;
            const response = await ServicesService.createService(data, token);
            toast.success(response);
        } catch (error) {
            toast.error('Error processing Service');
            console.error('Error processing Service:', error.message);
        } finally {
            setFormLoading(false);
            setShowServiceModal(false);
        }
    };

    const handleCustomerSubmit = async (data) => {
        setFormLoading(true);
        try {
            const token = user.token;
            if (data.id) {
                const response = await CustomerService.updateCustomer(data.id, data, token);
                toast.success(response);
            } else {
                const response = await CustomerService.createCustomer(data);
                toast.success(response);
            }
            fetchCustomers();
        } catch (error) {
            toast.error('Error processing customer');
            console.error('Error processing customer:', error.message);
        } finally {
            setFormLoading(false);
            setShowCustomerModal(false);
        }
    };

    const handleAssignSubmit = async (data) => {
        setFormLoading(true);
        try {
            const token = user.token;
            if (data.remove) {
                const response = await CRMUserService.removeCities(data, token);
                toast.success(response);
            } else {
                const response = await CRMUserService.addCities(data, token);
                toast.success(response);
            }
        } catch (error) {
            toast.error('Error assigning customer');
            console.error('Error assigning customer:', error.message);
        } finally {
            setFormLoading(false);
            setShowCustomerAssignModal(false);
        }
    };

    const handleAdvertisementSubmit = async (data) => {
        setFormLoading(true);
        try {
            const token = user.token;
            const response = await AdvertisementService.createAdvertisement(data, token);
            toast.success(response);
        } catch (error) {
            toast.error('Error processing AD');
            console.error('Error processing AD:', error.message);
        } finally {
            setFormLoading(false);
            setShowAdvertisementModal(false);
        }
    };

    const handleUpdateAdvertisement = async (data) => {
        setFormLoading(true);
        try {
            const token = user.token;
            const response = await AdvertisementService.updateAdvertisement(data.id, data, token);
            toast.success(response);
            fetchAdvertisementsList();
        } catch (error) {
            toast.error('Error updating AD');
            console.error('Error updating AD:', error.message);
        } finally {
            setFormLoading(false);
            setEditingAd(null);
        }
    };

    const viewAdvertisements = (customerId) => {
        setSelectedCustomerId(customerId);
        setShowCustomerADs(true);
    };

    const addAdvertisement = (customer) => {
        setSelectedCustomerId(customer.id);
        setSelectedCustomer(customer);
        setShowAdvertisementModal(true);
    };

    const editCustomer = (customer) => {
        setSelectedCustomer(customer);
        setShowCustomerModal(true);
    };

    const deleteCustomer = async (customerId) => {
        if (window.confirm('Are you sure you want to delete this customer?')) {
            try {
                const token = user.token;
                const response = await CustomerService.deleteCustomer(customerId, token);
                toast.success(response);
                fetchCustomers();
            } catch (error) {
                toast.error('Error processing customer');
                console.error('Error processing customer:', error.message);
            }
        };
    };

    const escapeCsv = (value) => {
        if (value === null || value === undefined) return '';
        const str = String(value);
        return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
    };

    const downloadCsv = (filename, headers, rows) => {
        const lines = [headers.join(',')];
        rows.forEach(row => lines.push(row.map(escapeCsv).join(',')));
        const blob = new Blob(['﻿' + lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${filename}-${new Date().toISOString().slice(0, 10)}.csv`;
        link.click();
        URL.revokeObjectURL(url);
    };

    const fetchAllPages = async (fetchPage) => {
        const exportSize = 1000;
        let all = [];
        let page = 0;
        let pages = 1;
        while (page < pages) {
            const response = await fetchPage(page, exportSize);
            all = all.concat(response.content || []);
            pages = response.totalPages || 1;
            page += 1;
        }
        return all;
    };

    const handleExportCsv = async () => {
        setExporting(true);
        try {
            const storedUser = JSON.parse(localStorage.getItem('user'));
            const token = storedUser?.token;

            if (viewType === 'advertisements') {
                const params = adQueryParams();
                const all = await fetchAllPages((page, size) =>
                    AdvertisementService.getAdvertisements(page, size, token, null, params));
                const headers = ['Id', 'Company', 'Image Path', 'Plan', 'AD Type', 'Plan Status', 'Amount', 'Payment', 'Start Date', 'End Date', 'City', 'Status', 'Date'];
                const rows = all.map(ad => [
                    ad.id, ad.companyName,
                    ad.imageName ? `${imageService.getAdsImage}${ad.imageName}` : '',
                    ad.planName, ad.adType === 'paid' ? 'Paid' : 'Free',
                    ad.adType === 'paid' ? (ad.planStatus === 'expired' ? 'Expired' : 'Active') : '',
                    ad.amount, ad.paymentCycle,
                    ad.startDate ? new Date(ad.startDate).toLocaleDateString() : '',
                    ad.endDate ? new Date(ad.endDate).toLocaleDateString() : '',
                    ad.city, ad.active ? 'Active' : 'Inactive',
                    ad.createdDate ? new Date(ad.createdDate).toLocaleDateString() : ''
                ]);
                downloadCsv('advertisements', headers, rows);
            } else {
                const role = storedUser.role.replace(/^\[|\]$/g, '');
                const all = await fetchAllPages((page, size) => {
                    if (searchTerm && searchBy) {
                        return CustomerService.searchCustomers(searchBy, searchTerm, page, size, token);
                    } else if (role === 'ROLE_SALES_MANAGER') {
                        return CustomerService.getAllCustomersByStatus(customersFilter, page, size, token);
                    }
                    return CustomerService.getCustomersForExecutive(loginUserDetails.id, customersFilter, page, size, token);
                });
                const headers = ['Id', 'Executive', 'Status', 'Company', 'Pr_Phone', 'Sc_Phone', 'City', 'State', 'Country', 'Source', 'Date'];
                const rows = all.map(c => [
                    c.id, c.executiveName, c.status, c.companyName, c.primaryPhone, c.secondaryPhone,
                    c.city, c.state, c.country, c.source,
                    c.createdDate ? new Date(c.createdDate).toLocaleDateString() : ''
                ]);
                downloadCsv('customers', headers, rows);
            }
        } catch (error) {
            toast.error('Export failed');
            console.error('Export failed:', error.message);
        } finally {
            setExporting(false);
        }
    };

    const handleSearch = (searchTerm, searchBy) => {
        setSearchTerm(searchTerm);
        setSearchBy(searchBy);
        setCurrentPage(0);
    };

    const handleFilter = (status) => {
        setCustomersFilter(status)
        setSearchTerm('');
        setSearchBy('');
        setCurrentPage(0);
    };

    return (<>
        {/* ---------------Dashborad Navigation Start----------------- */}

        <div className="followup_outer">
            {alerts.length > 0 && (
                <div className="followup_popup_msg">
                    {alerts.map((alert) => (
                        <div key={alert.id} className="follow_msg_box">
                            <Alert variant="warning text-left">
                                Message : <strong className="text-warning">{alert.message}</strong><br />
                                <strong>{alert.customeName}</strong> <br /><strong>{alert.customerPhone}</strong> -{" "}
                                {new Date(alert.followUpDate).toLocaleString()}
                            </Alert>

                            <Button
                                variant="link"
                                className="follow_done_btn"
                                onClick={() => handleFollowUpComplete(alert.id)}
                                aria-label="Done"
                            >
                                <i className="fa-solid fa-times"></i>
                            </Button>
                        </div>
                    ))}
                </div>
            )}
        </div>


        <section className="manage_dashoard_nav">
            <div className="container">
                <div className="row">
                    <nav className="navbar navbar-expand-lg navbar-dark">
                        <a className="navbar-brand">
                            {/* {loginUserDetails ? loginUserDetails.name : 'ORS CRM'}  */}
                            <h3><img src={logo} className='img-fluid' /> ORS - {loginUserDetails ? loginUserDetails.name : 'CRM'}</h3>
                        </a>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarContent" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        <div className="collapse navbar-collapse" id="navbarContent">
                            <ul className="navbar-nav ml-auto">
                                <li className="nav-item">
                                    <button
                                        className="btn btn-link nav-link"
                                        style={viewType === 'customers' ? { color: '#ffc107', fontWeight: 700, borderBottom: '2px solid #ffc107', borderRadius: 0 } : {}}
                                        onClick={() => setViewType('customers')}
                                    >
                                        Customers
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className="btn btn-link nav-link"
                                        style={viewType === 'advertisements' ? { color: '#ffc107', fontWeight: 700, borderBottom: '2px solid #ffc107', borderRadius: 0 } : {}}
                                        onClick={() => { setViewType('advertisements'); setAdCurrentPage(0); }}
                                    >
                                        Advertisements
                                    </button>
                                </li>
                                {loginUserDetails?.role === 'SALES_MANAGER' && (
                                    <li className="nav-item">
                                        <button className="btn btn-link nav-link" onClick={() => setshowPointRequest((prev) => !prev)}>{showPointRequest ? 'Customer':'Points Request'}</button>
                                    </li>
                                )}
                                <li className="nav-item">
                                    <button className="btn btn-link nav-link" onClick={() => setShowFollowUps(true)}>Today Follow-Ups</button>
                                </li>
                                {loginUserDetails && loginUserDetails.role === 'SALES_MANAGER' ? (
                                    <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" role="button" id="addDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            Actions
                                        </a>
                                        <div className="dropdown-menu" aria-labelledby="addDropdown">
                                            <button className="dropdown-item" onClick={() => { setShowCustomerModal(true); setSelectedCustomer(null); }}>Add Customer</button>
                                            <button className="dropdown-item" onClick={() => setShowServiceModal(true)}>Add Services</button>
                                            <button className="dropdown-item" onClick={() => setShowCustomerAssignModal(true)}>Assing Cities</button>
                                            <button className="dropdown-item" onClick={() => setShowAdActivationModal(true)}>Show/Hide Cities</button>
                                        </div>
                                    </li>
                                ) : (
                                    <li className="nav-item">
                                        <button className="btn btn-link nav-link" onClick={() => { setShowCustomerModal(true); setSelectedCustomer(null); }}><i className="fa-solid fa-plus"></i> Add Customer</button>
                                    </li>
                                )}
                            </ul>

                            <button className="btn btn-theme" onClick={handleLogout}>
                                <i className="fas fa-sign-out-alt"></i> Logout
                            </button>
                        </div>
                    </nav>


                </div>
            </div>
        </section>

        {/* ---------------Dashborad Navigation End----------------- */}


        <section className="manage_dashoard_content">
            <div className="container">
                <div className="row">
                  {!showPointRequest &&(
                    <div className="col-md-9 px-0">
                        <div className="dashboard-content-left">
                            <main className="main-table-content">
                                {viewType === 'customers' && (
                                    <StatusButtons setShowCustomers={handleFilter} />
                                )}
                                {loading ? (
                                    <div className="d-flex justify-content-center align-items-center vh-100">
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <span className="ms-3">Loading data...</span>
                                    </div>
                                ) : (<>
                                    {viewType === 'customers' && (
                                        <>
                                            <CustomerTable
                                                customers={customers}
                                                viewAdvertisements={viewAdvertisements}
                                                addAdvertisement={addAdvertisement}
                                                editCustomer={editCustomer}
                                                deleteCustomer={deleteCustomer}
                                                handleSearch={handleSearch}
                                                onExport={handleExportCsv}
                                                exporting={exporting}
                                                appliedSearch={{ by: searchBy, term: searchTerm }}
                                                customerId={(id) => setSelectedCustomerId(id)}
                                            />

                                            {totalPages > 1 && (
                                                <PaginationComponent
                                                    currentPage={currentPage}
                                                    totalPages={totalPages}
                                                    pageSize={size}
                                                    itemCount={customers.length}
                                                    totalItems={totalElements}
                                                    onPageChange={(pageNumber) => setCurrentPage(pageNumber)}
                                                />
                                            )}
                                        </>
                                    )}

                                    {viewType === 'advertisements' && (
                                        <>
                                            <AdvertisementTable
                                                advertisements={advertisements}
                                                onExport={handleExportCsv}
                                                exporting={exporting}
                                                onSearch={handleAdSearch}
                                                onFilter={handleAdFilter}
                                                filters={adFilters}
                                                appliedSearch={{ by: adSearchBy, term: adSearchTerm }}
                                                onEdit={(ad) => setEditingAd(ad)}
                                            />

                                            {adTotalPages > 1 && (
                                                <PaginationComponent
                                                    currentPage={adCurrentPage}
                                                    totalPages={adTotalPages}
                                                    pageSize={size}
                                                    itemCount={advertisements.length}
                                                    totalItems={adTotalElements}
                                                    onPageChange={(pageNumber) => setAdCurrentPage(pageNumber)}
                                                />
                                            )}
                                        </>
                                    )}
                                </>
                                )}

                            </main>
                        </div>
                    </div>
                  )}
                    {!showPointRequest &&(
                    <div className="col-md-3 px-0">
                        <div className="right_notes">
                            <aside className="right-side">
                                {loginUserDetails && (
                                    <CustomerStatusUpdate
                                        executiveId={loginUserDetails.id}
                                        customerId={selectedCustomerId}
                                        executiveName={loginUserDetails.name}
                                        handleFollowUpAdded={handleFollowUpAdded}
                                    />
                                )}
                            </aside>
                        </div>
                    </div>
                    )}

                    {loginUserDetails && (<CustomerModal
                        show={showCustomerModal}
                        handleClose={() => setShowCustomerModal(false)}
                        handleSubmit={handleCustomerSubmit}
                        customer={selectedCustomer}
                        executiveName={loginUserDetails.name}
                        response={formLoading}
                    />
                    )}

                    <ServiceModal
                        show={showServiceModal}
                        handleClose={() => setShowServiceModal(false)}
                        handleSubmit={handleServiceSubmit}
                        response={formLoading}
                    />

                    <CustomerAssignModal
                        show={showCustomerAssignModal}
                        handleClose={() => setShowCustomerAssignModal(false)}
                        handleSubmit={handleAssignSubmit}
                        response={formLoading}
                    />

                    <AdvertisementModal
                        show={showAdvertisementModal}
                        handleClose={() => setShowAdvertisementModal(false)}
                        handleSubmit={handleAdvertisementSubmit}
                        customer={selectedCustomer}
                        response={formLoading}
                    />

                    <AdvertisementModal
                        show={!!editingAd}
                        handleClose={() => setEditingAd(null)}
                        handleSubmit={handleUpdateAdvertisement}
                        advertisement={editingAd}
                        response={formLoading}
                    />

                    <ViewAdvertisementsModal
                        customerId={selectedCustomerId}
                        show={showCustomerADs}
                        onClose={() => setShowCustomerADs(false)}
                    />

                    {loginUserDetails && (
                        <ViewFollowUps
                        show={showFollowUps}
                        executiveId={loginUserDetails.id}
                        onClose={() => setShowFollowUps(false)}
                        handleFollowUpUpdate={handleFollowUpUpdate}
                        />
                    )}

                    <AdActivationByCity
                        showModal={showAdActivationModal}
                        handleCloseModal={()=>setShowAdActivationModal(false)}
                    />
                    {showPointRequest && (
                        <PointRequest/>
                    )}
                </div>
            </div>
        </section>
    </>

    );
}

export default ManagerDashboard;